module.exports = __webpack_public_path__ + "img/sa-gaming.50c2bed.png";